// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import 'ie-array-find-polyfill'
import Vue from 'vue'
import router from './router'
import App from './App'
import VueLocalStorage from 'vue-ls'
import VueAnalytics from 'vue-analytics'
import VueVisual from 'vue-visual'
import VueProgressBar from 'vue-progressbar'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VeeValidate from 'vee-validate'

Vue.config.productionTip = false

Vue.component('visual', VueVisual)

Vue.use(VueLocalStorage, {
  namespace: '_caam_'
})

Vue.use(VueProgressBar, {
  color: '#FFFFFF',
  failedColor: '#874b4b',
  thickness: '0.5vH',
  transition: {
    speed: '0.05s',
    opacity: '0s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
})

Vue.use(VueAwesomeSwiper)
Vue.use(VeeValidate)

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

Vue.use(VueAnalytics, {
  id: 'UA-103658114-1',
  router
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js